import React from 'react';

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;

interface InfoModalProps {
    title: string;
    content: React.ReactNode;
    onClose: () => void;
}

const InfoModal: React.FC<InfoModalProps> = ({ title, content, onClose }) => {
    return (
        <div onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50 page-enter-active" role="dialog" aria-modal="true">
            <div onClick={(e) => e.stopPropagation()} className="bg-gradient-to-br from-[#1a2a47] to-[#15243E] rounded-2xl border border-blue-900/50 w-full max-w-2xl text-gray-300 shadow-2xl flex flex-col max-h-[90vh]">
                <header className="p-6 border-b border-blue-900/50 flex justify-between items-center flex-shrink-0">
                    <h2 className="text-2xl font-bold text-white">{title}</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-white"><CloseIcon /></button>
                </header>

                <div className="p-6 overflow-y-auto">
                    <div className="prose prose-invert max-w-none prose-p:text-gray-300 prose-headings:text-white prose-a:text-yellow-400 prose-strong:text-white">
                        {content}
                    </div>
                </div>

                <footer className="p-4 border-t border-blue-900/50 mt-auto flex justify-end flex-shrink-0">
                    <button
                        onClick={onClose}
                        className="bg-yellow-400 text-gray-900 font-bold py-2 px-6 rounded-lg hover:bg-yellow-300 transition-transform hover:scale-105"
                    >
                        Close
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default InfoModal;